import PropTypes from 'prop-types';

const AddOnDetailsPropTypes = {
  vfScreenProps: PropTypes.object,
  onClose: PropTypes.func,
  onBack: PropTypes.func,
  showBack: PropTypes.bool,
  withTray: PropTypes.bool,
  images: PropTypes.object,
  mode: PropTypes.string,
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      role: PropTypes.string,
      '@type': PropTypes.string,
    }),
  ),
  id: PropTypes.string,
  status: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  name: PropTypes.string,
  validFor: PropTypes.shape({
    endDate: PropTypes.string,
    startDate: PropTypes.string,
  }),
  price: PropTypes.shape({
    type: PropTypes.string,
    recurringPeriod: PropTypes.string,
    unitOfMeasure: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    currency: PropTypes.string,
  }),
  icon: PropTypes.any,
  image: PropTypes.any,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  descriptionNumberOfLines: PropTypes.number,
  onToggleAutoRenew: PropTypes.func,
  isAutoRenewable: PropTypes.bool,
  onPrimaryButtonPress: PropTypes.func,
  onSecondaryButtonPress: PropTypes.func,
  isCurrencyFirst: PropTypes.bool,
  onUsersPress: PropTypes.func,
  addUserIcon: PropTypes.string,
  withPriceVat: PropTypes.bool,
};

export default AddOnDetailsPropTypes;
